import { JsonConvert, JsonConverter, JsonCustomConvert, JsonObject, JsonProperty } from "json2typescript";
import { BaseResponse } from "../base-response";

@JsonConverter
export class TiltConverter implements JsonCustomConvert<Tilt> {
  serialize() { }
  deserialize(data: any): Tilt {
    const jsonConvert: JsonConvert = new JsonConvert();
    return jsonConvert.deserializeObject(data, Tilt);
  }
}

@JsonObject("Tilt")
export class Tilt {
    @JsonProperty("attenuation", Number, true)
    attenuation: number = 0;
    @JsonProperty("percentageOfLength", Number, true)
    percentageOfLength: number = 0;
}
